import { render, staticRenderFns } from "./Action.vue?vue&type=template&id=84be7582&scoped=true"
import script from "./Action.vue?vue&type=script&lang=js"
export * from "./Action.vue?vue&type=script&lang=js"
import style0 from "./Action.vue?vue&type=style&index=0&id=84be7582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84be7582",
  null
  
)

export default component.exports